export enum ErrorKind {
    OFFLINE_UNAVAILABLE = "OFFLINE_UNAVAILABLE",
    UNKNOWN_ERROR = "UNKNOWN_ERROR",
    INVALID_SCENE = "INVALID_SCENE",
    DELETED_SCENE = "DELETED_SCENE",
    NOT_AUTHORIZED = "NOT_AUTHORIZED",
    EMPTY_PROJECT = "EMPTY_PROJECT",
    INIT_CANVAS_ERROR = "INIT_CANVAS_ERROR",
}
